import { render, staticRenderFns } from "./ScreeningWorkflowPanel.vue?vue&type=template&id=737aee59&"
import script from "./ScreeningWorkflowPanel.vue?vue&type=script&lang=js&"
export * from "./ScreeningWorkflowPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
